import { ButtonComponent } from 'src/app/components/button/button.component';
import { ButtonIconComponent } from './../button/button-icon/button-icon.component';
import { Component, AfterViewChecked, ViewChildren, QueryList, Input, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { AlignmentOption } from 'src/app/types/allignments';

@Component({
  selector: 'app-alignment-input',
  templateUrl: './alignment-input.component.html',
  styleUrls: ['./alignment-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlignmentInputComponent implements AfterViewChecked {


  @Input() alignment: AlignmentOption = 'left';
  @Output() alignmentChange = new EventEmitter<AlignmentOption>();

  @ViewChildren(ButtonComponent) buttons: QueryList<ButtonComponent>;

  public get value(): AlignmentOption {
    return this.alignment;
  }
  public set value(align: AlignmentOption) {
    this.Align(align);

  }
  private _ready = true;
  constructor(private cdr: ChangeDetectorRef) { }


  ngAfterViewChecked(): void {
    this._ready = true;
    this.Align(this.alignment);
  }
  Align(alignment: AlignmentOption) {

    this.alignment = alignment;
    this.alignmentChange.emit(this.alignment);
    this.Refresh();
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }

}
